import script from "./WatchlistContext.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistContext.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistContext.vue?vue&type=style&index=0&id=062998a4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062998a4"]])

export default __exports__